/* unplugin-vue-components disabled */import script from "./TestInteraction.vue?vue&type=script&setup=true&lang=js"
export * from "./TestInteraction.vue?vue&type=script&setup=true&lang=js"

import "./TestInteraction.vue?vue&type=style&index=0&id=00cbe41e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cbe41e"]])

export default __exports__